import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import API_BASE_URL from "../config/api";

export default function ActivePlans() {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem("user"));

    // NOT LOGGED IN
    if (!user?.id) {
      Swal.fire("Not Logged In", "Please login again", "warning").then(() => {
        navigate("/login");
      });
      setLoading(false);
      return;
    }

    // FETCH ACTIVE PLANS
    const fetchPlans = async () => {
      try {
        const res = await fetch(
          `${API_BASE_URL}/get_user_subscriptions.php`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ user_id: user.id }),
          }
        );

        const data = await res.json();

        if (data.success && Array.isArray(data.subscriptions)) {
          setPlans(
            data.subscriptions.filter(
              (p) => Number(p.days_left) > 0
            )
          );
        } else {
          setPlans([]);
        }
      } catch (err) {
        console.error("Active plan fetch error", err);
        setPlans([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPlans();
  }, [navigate]);

  // LOADING
  if (loading) {
    return (
      <div className="text-center py-5 fw-semibold text-muted">
        Loading active plans...
      </div>
    );
  }

  return (
    <div className="pt-4 bg-light">

        {/* ================= CARD ================= */}
        <div className="card border-0 shadow-sm rounded-4 p-3">

          {/* CARD HEADER */}
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
            <h3 className="mb-0">Active Plans</h3>

            {/* BUTTON ALWAYS PRESENT */}
            <Link
              to="/subscription"
              className="btn btn-outline-primary fw-semibold"
            >
              <i className="fa-solid fa-plus me-2"></i>
              Add Subscription
            </Link>
          </div>

          <hr className="my-3" />

          {/* ================= CONTENT ================= */}
          {plans.length === 0 ? (
            /* PROFESSIONAL EMPTY STATE */
            <div className="text-center py-4 text-muted">
              <div className="mb-2 fw-semibold">
                No active plans available
              </div>
              <div className="small">
                You currently don’t have an active subscription.
                Add a plan to access courses and mock tests.
              </div>
            </div>
          ) : (
            /* ACTIVE PLANS LIST */
            <div className="d-flex flex-wrap gap-3">
              {plans.map((plan) => (
                <div
                  key={plan.purchase_id}
                  className="d-flex align-items-center gap-3 px-3 py-2 bg-light rounded-3"
                  style={{ minWidth: "240px" }}
                >
                  <div className="text-warning fs-4">
                    <i className="fa-solid fa-crown"></i>
                  </div>

                  <div className="text-start">
                    <div className="fw-semibold">
                      {plan.plan_name}
                    </div>
                    <div className="text-muted small">
                      <i className="fa-regular fa-clock me-1"></i>
                      {plan.days_left} days remaining
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

        </div>

    </div>
  );
}
